const REFER_FRIEND = {
  GET_ALL_INVITATIONS: 'gamification/api/v1.1/invitation/list' as 'gamification/api/v1.1/invitation/list',
  RESEND_INVITATION: 'gamification/api/v1.1/invitation/resend' as 'gamification/api/v1.1/invitation/resend',
}

export default REFER_FRIEND
